import { DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { KwhPipe } from './kwh.pipe';

@NgModule({
  declarations: [KwhPipe],
  providers: [KwhPipe, DecimalPipe],
  imports: [TranslatePipe],
  exports: [KwhPipe],
})
export class KwhModule {}
